import gql from "graphql-tag";
import { DocumentNode, PureQueryOptions } from "@apollo/client";
import { GraphQlQueryBuilder } from "../graphQl-query.builder";
import { TableField } from "../../table/table.field.model";
import { forEach } from "lodash";

interface TipoDatoTableDatasGraphQL {
  tableId: string;
  first: number;
  offset: number;
}

const FLOAT_TYPE: string = "Float";
const STRING_TYPE: string = "String";
const BOOLEAN_TYPE: string = "Boolean";
const OBJECT_TYPE: string = "Object";
const INT_TYPE: string = "Int";

export class TipoDatoTableDatasGQlBuilder {
  private _tableId: string;
  private _offset: number;
  private _first: number;
  private _structData: TableField[];

  private get _query(): DocumentNode {
    let queryRequest = `query findTipoDatoTableDatas($first: Int, $offset: Int, $tableId: String){ 
            findTipoDatoTableDatas(first: $first, offset: $offset, td: $tableId) { 
                total
                results {
                    ${this.getAllFields(5)}
                }
            }
          }`;

    return gql(queryRequest);
  }

  public getAllFields(maxLevel: number) {
    let queryRequestData: string = "";

    queryRequestData = this.getNestedFields(maxLevel, this._structData);
    return queryRequestData;
  }

  private getNestedFields(maxLevel: number, paramStructData: TableField[]) {
    let queryRequestData: string = "";

    queryRequestData = queryRequestData + "_id\n";
    for (const tableFields of paramStructData) {
      queryRequestData = queryRequestData + tableFields.codigo_df + ": ";

      if (tableFields.tipo != OBJECT_TYPE) {
        queryRequestData =
          queryRequestData +
          this.getFuncSelectValue(tableFields.tipo, tableFields.codigo_df) +
          "{ value }\n";
      } else {
        queryRequestData =
          queryRequestData +
          this.getFuncSelectValue(tableFields.tipo, tableFields.codigo_df) +
          "{";
        queryRequestData =
          queryRequestData +
          this.getNestedFields(maxLevel, tableFields.childField);
        queryRequestData = queryRequestData + "}\n";
      }
    }

    return queryRequestData;
  }

  public withTableId(tableId: string): this {
    this._tableId = tableId;
    return this;
  }

  public withFirst(first: number): this {
    this._first = first;
    return this;
  }

  public withOffset(offset: number): this {
    this._offset = offset;
    return this;
  }

  public withStructData(structData: TableField[]): this {
    this._structData = structData;
    return this;
  }

  public build(): PureQueryOptions {
    let queryParams: TipoDatoTableDatasGraphQL;

    const graphQlBuilder: GraphQlQueryBuilder = new GraphQlQueryBuilder();
    queryParams = {
      tableId: this._tableId,
      first: this._first,
      offset: this._offset,
    };

    return graphQlBuilder
      .withQuery(this._query)
      .withParams(queryParams)
      .buildNoCache();
  }

  public getFuncSelectValue(typeValue: string, codeDef: string): string {
    let result: string = 'stringValue(code:"' + codeDef + '")';

    switch (typeValue) {
      case FLOAT_TYPE:
        result = 'floatValue(code:"' + codeDef + '")';
        break;
      case STRING_TYPE:
        result = 'stringValue(code:"' + codeDef + '")';
        break;
      case BOOLEAN_TYPE:
        result = 'booleanValue(code:"' + codeDef + '")';
        break;
      case OBJECT_TYPE:
        result = 'objectValue(code:"' + codeDef + '")';
        break;
      case INT_TYPE:
        result = 'intValue(code:"' + codeDef + '")';
        break;
    }

    return result;
  }
}
